import { getConfig } from "./api";
// 1. 获取版本号
export function checkVersion() {
  getConfig('version').then((res) => {
    console.log("线上verison", res.msg);
    console.log("本地verison", localStorage.getItem("version"));
    if (
      res.msg &&
      res.msg !== localStorage.getItem("version")
    ) {
      console.log("更新");
      localStorage.setItem("version", res.msg);
      RefreshPage();
    }
  });
}
let tirem = null;
//2. 更新页面逻辑
function RefreshPage() {
  let time = 60000;
  const isConfirm = confirm("有可用更新，是否立即更新");
  if (isConfirm) {
    return window.location.reload();
  } else {
    tirem = setTimeout(() => {
      if (tirem) {
        clearTimeout(tirem);
      }
      RefreshPage();
    }, time);
  }
}
